import { render, staticRenderFns } from "./yhwt.vue?vue&type=template&id=22e110b6&scoped=true&"
import script from "./yhwt.vue?vue&type=script&lang=js&"
export * from "./yhwt.vue?vue&type=script&lang=js&"
import style0 from "./yhwt.vue?vue&type=style&index=0&id=22e110b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e110b6",
  null
  
)

export default component.exports